module.exports = "/_next/static/resources/single-8e63b425fffef2f5c0b04409afcfe128.jpg";